export default "__VITE_ASSET__2I5mDJ7C__"